import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

import {Box, Button, Paper} from "@mui/material";
import FlightSummary from "./FlightSummary";
import FlightInput from "./FlightInput";
import FlightSelectionFromDuffel from "./FlightSelectionFromDuffel";
import FlightGoogleMap from "./FlightGoogleMap";
import {PAContext} from "../../../Services/PAContext";

import FlightInputSearch from "./FlightInputSearch";
import dayjs from "dayjs";
import FlightSelectionFromSearch from "./FlightSelectionFromSearch";
import { v4 as uuidv4 } from 'uuid';
import FlightSummaryForDuffel from "./FlightSummaryForDuffel";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import PAAttendee from "../../../MasterEventObjects/Attendee";





const FlightPlanner = (
    {
        setSelectedMenuItem,
        isSearching,
        searchingFor,
        _global_map_ref
    }) => {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject} = usePA_GlobalStore();

    const { dataArray, sendSocketMessage, setSideMenuWidth, removeFirstFlightPlanningActions } = useContext(PAContext);
    const { authenticated, FlightPlanningPipeline } = dataArray;

    // State to toggle between FlightInput and FlightInputAlternative
    const [useAlternativeInput, setUseAlternativeInput] = useState(true);


    // State to track selected departure and destination airports
    const [departureAirport, setDepartureAirport] = useState(null);
    const [destinationAirport, setDestinationAirport] = useState(null);

    const [flightMode, setFlightMode] = useState('getting_there'); // getting_there | getting_back
    const [searchResults, setSearchResults] = useState([]); // flights returned from search
    const [flightsOnMap, setFlightsOnMap] = useState([]); // flights with Map It checked
    const [selectedFlights, setSelectedFlights] = useState({
        getting_there: [],
        getting_back: []
    });
    useEffect(() => {
        console.log("selectedFlights : ", selectedFlights);
    }, [selectedFlights]);
    const handleUpdateSelectedFlights = (mode, updatedFlights) => {
        setSelectedFlights(prev => ({ ...prev, [mode]: updatedFlights }));
    };

    /*
        for the Flight Search from FlightStats
     */
    const handleFlightSearch = ({ airlineCode, flightNumber, date }) => {
        console.log("handleFlightSearch : "+airlineCode+" : "+flightNumber+" : "+date);

        // Extract year, month, and day from the 'date'
        const departDate = dayjs(date);
        const departDateYear = departDate.year();
        const departDateMonth = departDate.month() + 1;  // month is zero-indexed, so add 1
        const departDateDay = departDate.date();

        //send to server
        const _send_string = {};
        _send_string.action = "E_getFlightDetails";
        _send_string.airline_id = airlineCode;
        _send_string.flight_number = flightNumber;
        _send_string.depart_airport_id = "";
        _send_string.arrive_airport_id = "";
        _send_string.depart_date_year = departDateYear;
        _send_string.depart_date_month = departDateMonth;
        _send_string.depart_date_day = departDateDay;

        console.log("_send_string : ", _send_string);

        sendSocketMessage(_send_string);

    }


    // Handle real-time changes in airport selection
    const handleAirportChange = ({ departure, destination }) => {
        setDepartureAirport(departure);
        setDestinationAirport(destination);
    };

    // Handle the results from the flight input
    const handleFlightSearchFromDuffel = (searchParams) => {
        console.log("handleFlightSearchFromDuffel : ",searchParams);

        const _sendString = {};
        _sendString.action = "E_getDuffelFlights";
        _sendString.departure_airport = searchParams.departure.iata;        //the three letter airport code
        _sendString.destination_airport = searchParams.destination.iata;    //the three letter airport code
        _sendString.date = searchParams.date;                               //departure date
        _sendString.max_connections = searchParams.maxConnections;
        _sendString.useTestData = searchParams.useTestData;                 // Include the test data toggle value

        sendSocketMessage(_sendString);

    };

    useEffect(() => {
        console.log('searchResults : ', searchResults);
    }, [searchResults]);

    useEffect(() => {
        if (FlightPlanningPipeline.length === 0) return; // Prevent unnecessary runs

        console.log("Something new in the FlightPlanningPipeline : "+FlightPlanningPipeline.length);
        FlightPlanningPipeline.forEach(_incoming => {
            if (_incoming.result === "ok") {
                if (_incoming.action === "E_getFlightDetailsResults") {
                    processFlightSearchResults(_incoming);
                } else if (_incoming.action === "E_getDuffelFlightsResults"){
                    if (_incoming.flights?.length > 0){
                        setSearchResults(_incoming.flights);
                    }
                }
            }
        });

        // ✅ Ensure we remove processed actions
        removeFirstFlightPlanningActions();

    }, [FlightPlanningPipeline]);

    const generateFlightId = () => {
        return uuidv4(); // Generates a UUID string
    };

    function processFlightSearchResults(_incoming) {
        if (_incoming.flight_details.scheduledFlights !== undefined) {
            const _flight_details = _incoming.flight_details;
            const _scheduled_flights = _flight_details.scheduledFlights;



            if (_scheduled_flights.length === 0) {
                // No flights found
                console.log("No Flights Found");
            } else  {
                // flight(s) found
                const _flightResults = [];

                _scheduled_flights.map((_flight) => {

                    const _scheduled_flight = _flight;
                    const _attached_appendix = _flight_details.appendix;
                    const _appendix_airlines = _attached_appendix.airlines;
                    const _appendix_airports = _attached_appendix.airports;

                    //get the airline info
                    let _airline_name = "";
                    let _flight_identity = "";

                    for (const _airline of _appendix_airlines){
                        if (_scheduled_flight.isWetLease){
                            if (_airline.iata === _scheduled_flight.wetleaseOperatorFsCode){
                                _airline_name = _airline.name;
                                _flight_identity = _airline.icao+""+_incoming.flight_number;
                                break;
                            }
                        } else {
                            if (_airline.icao === _incoming.airline_id || _airline.fs === _incoming.carrierFsCode){
                                _airline_name = _airline.name;
                                _flight_identity = _airline.icao+" "+_incoming.flight_number;
                                break;
                            }
                        }
                    }

                    let _depart_airport_name = "";
                    let _depart_airport_city = "";
                    let _depart_airport_latitude = 0.0;
                    let _depart_airport_longitude = 0.0;
                    let _depart_airport_timezone = "";
                    let _depart_airport_timezone_offset = 0;
                    let _arrive_airport_name = "";
                    let _arrive_airport_city = "";
                    let _arrive_airport_latitude = 0.0;
                    let _arrive_airport_longitude = 0.0;
                    let _arrive_airport_timezone = "";
                    let _arrive_airport_timezone_offset = 0;

                    for (const _airport of _appendix_airports){
                        if (_airport.iata === _scheduled_flight.departureAirportFsCode || _airport.fs === _scheduled_flight.departureAirportFsCode){
                            //departing airport
                            _depart_airport_name = _airport.name;
                            _depart_airport_city = _airport.city;
                            _depart_airport_latitude = _airport.latitude;
                            _depart_airport_longitude = _airport.longitude;
                            _depart_airport_timezone = _airport.timeZoneRegionName;
                            _depart_airport_timezone_offset = parseInt(_airport.utcOffsetHours);
                        }
                        if (_airport.iata === _scheduled_flight.arrivalAirportFsCode || _airport.fs === _scheduled_flight.arrivalAirportFsCode){
                            //arriving airport
                            _arrive_airport_name = _airport.name;
                            _arrive_airport_city = _airport.city;
                            _arrive_airport_latitude = _airport.latitude;
                            _arrive_airport_longitude = _airport.longitude;
                            _arrive_airport_timezone = _airport.timeZoneRegionName;
                            _arrive_airport_timezone_offset = parseInt(_airport.utcOffsetHours);
                        }

                    }

                    const _flight_info = {};
                    const _temp = PAAttendee.generateRandomString(24);
                    _flight_info.temp_id = _temp;
                    _flight_info.id = _temp;
                    _flight_info.airline_code = _incoming.airline_id;
                    _flight_info.ident = _incoming.airline_id+" "+_incoming.flight_number;
                    _flight_info.actual_ident = "";
                    _flight_info.flight_number = _incoming.flight_number;

                    //set the airline name
                    _flight_info.airline_name = _airline_name;

                    _flight_info.origin = _scheduled_flight.departureAirportFsCode;
                    _flight_info.destination = _scheduled_flight.arrivalAirportFsCode;

                    _flight_info.depart_airport_code = _scheduled_flight.departureAirportFsCode;
                    _flight_info.depart_airport_name = _depart_airport_name;
                    _flight_info.depart_airport_city = _depart_airport_city;
                    _flight_info.depart_airport_latitude = _depart_airport_latitude;
                    _flight_info.depart_airport_longitude = _depart_airport_longitude;
                    _flight_info.depart_timestamp = _scheduled_flight.departureTime;
                    _flight_info.depart_timezone = _depart_airport_timezone;
                    _flight_info.depart_timezone_offset = _depart_airport_timezone_offset;

                    _flight_info.arrive_airport_code = _scheduled_flight.arrivalAirportFsCode;
                    _flight_info.arrive_airport_name = _arrive_airport_name;
                    _flight_info.arrive_airport_city = _arrive_airport_city;
                    _flight_info.arrive_airport_latitude = _arrive_airport_latitude;
                    _flight_info.arrive_airport_longitude = _arrive_airport_longitude;
                    _flight_info.arrive_timestamp = _scheduled_flight.arrivalTime;
                    _flight_info.arrive_timezone = _arrive_airport_timezone;
                    _flight_info.arrive_timezone_offset = _arrive_airport_timezone_offset;

                    _flight_info.delay_minutes = 0;

                    _flight_info.depart_terminal = "";
                    _flight_info.depart_gate = "";
                    _flight_info.arrive_terminal = "";
                    _flight_info.arrive_gate = "";
                    _flight_info.baggage_claim = "";

                    _flight_info.attendees = PA_GlobalObject.Planning.attendees
                        .filter((att) => att.role !== 'planner' && att.role !== 'partial' && att.rsvp !== 'decline')
                        .map((att) => ({
                            id: att.id,
                            cost: 0,
                            is_business_expense: false,
                            business_expense_amount_authorized: 0,
                            business_expense_amount_authorized_by: "",
                            business_expense_amount_authorized_timestamp: 0,
                            business_expense_amount: 0,
                            business_expense_paid: 0,
                            business_expense_reference_id: "",
                        }));

                    _flight_info.amount_total = 0;
                    _flight_info.currency = PA_GlobalObject.Planning.budget_currency || 'USD';
                    _flight_info.alerts_enabled = false;
                    _flight_info.cirium_alert_id = "";

                    _flight_info.last_known_status = false;
                    _flight_info.status = "";
                    _flight_info.status_timestamp = 0;

                    console.log("_flight_info", _flight_info);
                    _flightResults.push(_flight_info);

                });

                //add to the search results
                setSearchResults(_flightResults);

            }
        }
    }



    // This function will be shared between FlightSelection and FlightGoogleMap
    const handleFlightSelection = (flightId) => {
        setSelectedFlights((prev) => {
            // 1. Identify which array to look at based on flightMode
            const currentList = prev[flightMode];

            // 2. Check if the flight is already in THAT specific array
            const isAlreadySelected = currentList.some((flight) => flight.id === flightId);

            if (isAlreadySelected) {
                // 3. Remove from the specific array while keeping the other intact
                return {
                    ...prev,
                    [flightMode]: currentList.filter((flight) => flight.id !== flightId)
                };
            } else {
                // 4. Find the flight in results and add it to the specific array
                const selectedFlight = searchResults.find((flight) => flight.id === flightId);

                // Only update if the flight was actually found
                if (!selectedFlight) return prev;

                return {
                    ...prev,
                    [flightMode]: [...currentList, selectedFlight]
                };
            }
        });
    };

    const handleAddFlightToEvent = (flightId) => {

        console.log("trying to add a flight :", flightId);
        console.log("flightMode :", flightMode);

        const originalFlight = selectedFlights[flightMode].find(f => f.id === flightId);

        console.log("flight found :", originalFlight);

        // 1. Safeguards
        if (!originalFlight || !originalFlight.attendees) return;

        // 1. Destructure: Pull 'attendees' out, keep the 'rest' in 'flightData'
        const { attendees, ...flightData } = originalFlight;

        // 2. Create the array of individual flight objects (One for each attendee)
        // We use .map to return a brand new array of unique objects
        const newFlightsBatch = originalFlight.attendees.map(attendee => {
            return {
                ...flightData, // Copy all properties
                id: PAAttendee.generateRandomString(24), // Assign unique ID
                attendee: attendee, // Assign specific attendee
                flight_group_id: 0
            };
        });

        console.log("newFlightsBatch :", newFlightsBatch);

        // 3. Update State ONCE (Batch Update)

        set_PA_GlobalObject(prev => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                flights: [...prev.Planning.flights, ...newFlightsBatch],
            },
        }));

        // 4. Send to Server ONCE
        if (authenticated && PA_GlobalObject.Planning.status !== 10) {
            const payload = {
                action: "E_addNewFlightDetails_v2",
                event_id: PA_GlobalObject.Planning.id,
                // Pass the whole array!
                // Your Java backend (which we fixed earlier) is now ready for a list.
                flights: newFlightsBatch
            };

            sendSocketMessage(payload);
        }
    }

    const handleDeleteFlight = (flightId) => {
        setSelectedFlights(prev => ({
            ...prev,
            [flightMode]: prev[flightMode].filter(flight => flight.id !== flightId),
        }));

        // Remove from event if it was added
        set_PA_GlobalObject(prev => ({
            Planning: {
                ...prev.Planning,
                flights: prev.Planning.flights.filter(f => f.id !== flightId),
            },
        }));
    };

    // Send selected flights to the map and summary components
    const handleMapUpdate = () => {
        return selectedFlights; // Pass selected flights to GoogleMap
    };

    const handleSummaryUpdate = () => {
        return selectedFlights; // Pass selected flights to FlightSummary
    };

    const [isFlightSummaryExpanded, setIsFlightSummaryExpanded] = useState(false);

    const toggleFlightSummary = () => {
        setIsFlightSummaryExpanded((prev) => !prev);
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100vh - 100px)', // Full height minus page header layout padding
                padding: '10px',
                boxSizing: 'border-box' // Force padding calculations inside the height window limit
            }}
        >

            {/* Toggle and Navigation Row */}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'stretch', // 🚀 CRITICAL: Stretches the left Box to match the height of the inputs input
                    marginBottom: '20px',
                    flexShrink: 0
                }}
            >
                {/* 🎯 VERTICAL HUB: Keeps buttons aligned and handles exact positioning */}
                <Box
                    sx={{
                        marginRight: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', // 🚀 CENTERS CHILDS PERMANENTLY: Anchors the toggle to the direct center
                        alignItems: 'flex-start',
                        width: '150px',
                        position: 'relative',    // 🚀 ANCHOR POINT: Allows us to lock the back button to the top of this box
                        flexShrink: 0
                    }}
                >
                    {/* 1. Navigation Link (Positioned at the absolute top of the entire row height) */}
                    <Button
                        variant="text"
                        onClick={() => {
                            // 🚀 COMBINED STATE & ROUTING ACTION
                            setSelectedMenuItem('planner');
                            setSideMenuWidth(0);
                            navigate('/Planner/Itinerary');
                        }}
                        startIcon={<i className="icon-arrow-left" style={{ fontSize: '11px', fontWeight: 900 }} />}
                        sx={{
                            position: 'absolute', // 🚀 FLOATS OVER LAYOUT FLOW
                            top: 0,               // Snaps it to the absolute top edge of the parent container
                            left: 0,
                            color: '#10b981',
                            fontWeight: 800,
                            fontSize: '0.72rem',
                            textTransform: 'none',
                            borderRadius: '6px',
                            padding: '2px 6px',
                            minWidth: 'unset',
                            '&:hover': {
                                bgcolor: 'rgba(16, 185, 129, 0.06)'
                            }
                        }}
                    >
                        to Planner
                    </Button>

                    {/* 2. Mode Toggle Button (Natively centered inside the full height box context) */}
                    <Button
                        variant="outlined"
                        onClick={() => setUseAlternativeInput(!useAlternativeInput)}
                        sx={{
                            width: '100%',
                            height: '36px',
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: '13px',
                            borderColor: '#f09637',
                            color: '#f09637',
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(8px)',
                            mt: '16px', // Prevents the toggle button from overlapping the text link if your inputs are thin
                            '&:hover': {
                                borderColor: '#e08324',
                                background: 'rgba(240, 150, 55, 0.08)',
                            }
                        }}
                    >
                        {useAlternativeInput ? 'Flight Prices' : 'Flight Search'}
                    </Button>
                </Box>

                {/* Input section taking up all remaining row space */}
                <div style={{ flexGrow: 1 }}>
                    {useAlternativeInput ? (
                        <FlightInputSearch
                            onSearch={handleFlightSearch}
                            flightMode={flightMode}
                            setFlightMode={setFlightMode}
                        />
                    ) : (
                        <FlightInput
                            onSearch={handleFlightSearchFromDuffel}
                            onAirportChange={handleAirportChange}
                            departureAirport={departureAirport}
                            destinationAirport={destinationAirport}
                        />
                    )}
                </div>
            </div>

            {/* Second Row: FlightSelection, FlightGoogleMap, and FlightSummary side by side */}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexGrow: 1, // 🚀 Dynamically claims all remaining viewport height
                    height: 'calc(100vh - 250px)', // Safe hardcoded calculation boundary fallback
                    overflow: 'hidden'
                }}
            >
                {/* COLUMN 1: FlightSelection */}
                <div
                    style={{
                        minWidth: '200px',
                        width: '25%', // Dynamic baseline size assignment
                        maxWidth: '300px',
                        marginRight: '10px',
                        flexShrink: 0,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            padding: '10px',
                            overflowY: 'auto',
                            height: '100%',
                            boxSizing: 'border-box'
                        }}
                    >
                        {useAlternativeInput ? (
                            <FlightSelectionFromSearch
                                searchResults={searchResults}
                                flightMode={flightMode}
                                flightsOnMap={flightsOnMap}
                                setFlightsOnMap={setFlightsOnMap}
                                selectedFlights={selectedFlights}
                                setSelectedFlights={setSelectedFlights}
                            />
                        ) : (
                            <FlightSelectionFromDuffel
                                searchResults={searchResults}
                                flightMode={flightMode}
                                flightsOnMap={flightsOnMap}
                                setFlightsOnMap={setFlightsOnMap}
                                selectedFlights={selectedFlights}
                                setSelectedFlights={setSelectedFlights}
                            />
                        )}
                    </Paper>
                </div>

                {/* COLUMN 2: FlightGoogleMap (Centric Hub Canvas View) */}
                <div
                    style={{
                        flexGrow: 1,
                        marginRight: '10px',
                        display: 'flex', // 🚀 Force child elements to inherit layout context rules
                        flexDirection: 'column',
                        height: '100%'
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            padding: '10px',
                            height: '100%', // 🚀 Lock internal bounding surface height
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden'
                        }}
                    >
                        {/* Ensure your internal canvas wrappers inherit height: '100%' inside FlightGoogleMap */}
                        <FlightGoogleMap
                            _global_map_ref={_global_map_ref}
                            flightsOnMap={flightsOnMap}
                            setFlightsOnMap={setFlightsOnMap}
                            onSelectFlight={handleFlightSelection}
                            departureAirport={departureAirport}
                            destinationAirport={destinationAirport}
                        />
                    </Paper>
                </div>

                {/* COLUMN 3: FlightSummary Checkout Panel */}
                <div
                    style={{
                        minWidth: '200px',
                        width: '25%',
                        maxWidth: '300px',
                        flexShrink: 0,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            padding: '10px',
                            height: '100%',
                            overflowY: 'auto',
                            boxSizing: 'border-box'
                        }}
                    >
                        {useAlternativeInput ? (
                            <FlightSummary
                                flightMode={flightMode}
                                setFlightMode={setFlightMode}
                                selectedFlights={selectedFlights}
                                handleUpdateSelectedFlights={handleUpdateSelectedFlights}
                                handleAddFlightToEvent={handleAddFlightToEvent}
                                handleDeleteFlight={handleDeleteFlight}
                            />
                        ) : (
                            <FlightSummaryForDuffel
                                selectedFlights={selectedFlights}
                            />
                        )}
                    </Paper>
                </div>
            </div>
        </div>
    );
};

export default FlightPlanner;